module.exports = __webpack_public_path__ + "img/f6027f3.png";